<template>
    <div class="moment-bars">
        <div v-for="bar in bars" :key="bar.label" class="moment-bar"
            :style="{ flexGrow: bar.pct, background: bar.bg, borderColor: bar.border, color: bar.color }"
            @click="$emit('select', bar)">
            <span class="moment-pct">{{ bar.pct }}%</span>
            <div class="moment-info">
                <span class="moment-lbl">{{ bar.label }}</span>
                <span class="moment-count">{{ $tc('statistics.injuries_count', bar.count, { count: bar.count }) }}</span>
            </div>
        </div>
        <div v-if="!bars.length" class="moment-empty">{{ $t('common.without_data') }}</div>
    </div>
</template>

<script>
export default {
    name: "InjuryMomentChart",
    props: {
        docs: {
            type: Array,
            default: null,
        }
    },
    data() {
        return {
            palette: [
                { bg: 'rgba(51,153,153,0.16)', border: 'rgba(51,153,153,0.32)', dark: '#66CCCC', light: '#2A7D7D' },
                { bg: 'rgba(0,153,102,0.16)', border: 'rgba(0,153,102,0.32)', dark: '#33CC99', light: '#0A7A56' },
                { bg: 'rgba(102,204,204,0.16)', border: 'rgba(102,204,204,0.32)', dark: '#99E0E0', light: '#2F8A8A' },
                { bg: 'rgba(204,153,0,0.16)', border: 'rgba(204,153,0,0.32)', dark: '#E6C34D', light: '#8A6D00' },
            ],
        }
    },
    computed: {
        bars(vm = this) {
            const docs = vm.docs.filter(d => d.wasIt)
            const total = docs.length || 1
            const isDark = vm.$vuetify.theme.dark
            const groups = {}
            docs.forEach(doc => {
                const label = vm.injuryMomentLabel(doc.wasIt)
                if (!groups[label]) groups[label] = []
                groups[label].push(doc)
            })

            return Object.entries(groups)
                .sort((a, b) => b[1].length - a[1].length)
                .map(([label, items], i) => {
                    const color = vm.palette[i % vm.palette.length]
                    return {
                        label,
                        items,
                        count: items.length,
                        pct: parseFloat((items.length / total * 100).toFixed(1)),
                        bg: color.bg,
                        border: color.border,
                        color: isDark ? color.dark : color.light,
                    }
                })
        },
    },
}
</script>

<style scoped>
.moment-bars {
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    min-height: 0;
}

.moment-bar {
    flex-basis: 0;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    border: 1px solid;
    border-radius: 9px;
    cursor: pointer;
    transition: filter 0.15s;
}

.moment-bar:hover {
    filter: brightness(1.15);
}

.moment-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1px;
    line-height: 1.2;
}

.moment-count {
    font-size: 10px;
    font-weight: 600;
    opacity: 0.55;
}

.moment-pct {
    font-size: 24px;
    font-weight: 800;
}

.moment-lbl {
    font-size: 13px;
    font-weight: 600;
    opacity: 0.85;
}

.moment-empty {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: var(--v-txtMuted-base);
}
</style>
